import { type Chain, type Hex, parseEther } from "viem"
import { ALL_ADDRESSES } from "../addresses"
import { getFundedAccount, toClients } from "../utils"

export type FundAccountsArgs = {
  rpcUrl: string
  chain: Chain
  privateKey?: Hex
}

export const fundAccounts = async ({ rpcUrl, chain }: FundAccountsArgs) => {
  const { publicClient, testClient, walletClients } = await toClients({
    rpcUrl,
    chain
  })

  const accountsAndContracts = [
    ...Object.values(ALL_ADDRESSES),
    ...walletClients.map(({ account }) => account)
  ]
  for (const { address } of accountsAndContracts) {
    const balance = await publicClient.getBalance({
      address: address as `0x${string}`
    })
    if (balance > 0n) {
      continue
    }
    await testClient.setBalance({
      address: address as `0x${string}`,
      value: parseEther("1")
    })
  }
}
